import { useCallback, useEffect, useRef, useState } from 'react'
import { BOARDS_HEIGHT_MAX, BOARDS_HEIGHT_MIN, BOARDS_HEIGHT_STORAGE_KEY, readStoredBoardsHeight } from './boardsSectionTokens.js'
import { boardsResizeKeyDown } from './boardsResizeKeyDown.js'

export function useBoardsSectionResize() {
  const [boardsHeightPx, setBoardsHeightPx] = useState(readStoredBoardsHeight)
  const resizeStartRef = useRef(null)

  useEffect(() => {
    try {
      localStorage.setItem(BOARDS_HEIGHT_STORAGE_KEY, String(boardsHeightPx))
    } catch {
      /* ignore */
    }
  }, [boardsHeightPx])

  const onResizePointerDown = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    resizeStartRef.current = { pointerId: e.pointerId, startY: e.clientY, startH: boardsHeightPx }
    e.currentTarget.setPointerCapture(e.pointerId)
  }, [boardsHeightPx])

  const onResizePointerMove = useCallback((e) => {
    const s = resizeStartRef.current
    if (s == null || e.pointerId !== s.pointerId) return
    const dy = e.clientY - s.startY
    setBoardsHeightPx(Math.round(Math.min(BOARDS_HEIGHT_MAX, Math.max(BOARDS_HEIGHT_MIN, s.startH + dy))))
  }, [])

  const onResizePointerUp = useCallback((e) => {
    const s = resizeStartRef.current
    if (s == null || e.pointerId !== s.pointerId) return
    resizeStartRef.current = null
    try {
      e.currentTarget.releasePointerCapture(e.pointerId)
    } catch {
      /* ignore */
    }
  }, [])

  const onResizeKeyDown = useCallback((e) => boardsResizeKeyDown(e, boardsHeightPx, setBoardsHeightPx), [boardsHeightPx])

  return { boardsHeightPx, onResizePointerDown, onResizePointerMove, onResizePointerUp, onResizeKeyDown }
}
